import logo from './images/logo.png';
import React, { useState, useRef, useEffect } from 'react'
import Fade from '@mui/material/Fade';
import api from './Services/Api';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import Alert from '@mui/material/Alert';
import FeedbackIcon from '@mui/icons-material/Feedback';
import { useTranslation } from 'react-i18next';
import i18n from './Services/i18n';
function App() {
    const navigate = useNavigate();
    const [noCreditsLeft, setNoCreditsLeft] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        api.getUserData().then((response) => {
            navigate("/app");
        }).catch((error) => {
            try {
                if (error.response.status == 401 && error.response.data.message != 'Unauthorized') {
                    setNoCreditsLeft(true);
                }
            } catch (error) {
                console.log("Error parsing error", error)
            }
            
            logout();
        });
    }, []);

    function logout() {
        api.logout();
        navigate("/");
    }
    
    function login() {
        window.location.replace(`${api.baseURL}/install`)
    }

    return (
        <div style={{height: "100vh"}}>
            <div style={{height: "100vh", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center"}}>
                <Fade in={true} timeout={3000} easing={1000}>
                    <img id="logo" src={logo} alt="logo" style={{ width: "40%", maxWidth: "300px", transition: "all 1s ease-in-out" }} />
                </Fade>
                {!noCreditsLeft && <Button variant="contained" size="large" color="info" onClick={() => { login() }} style={{ marginTop: "2rem", color: "#002657" }}>{t('login')}</Button>}
            </div>
            {noCreditsLeft &&
                <Alert severity="error" style={{ position: "fixed", bottom: "5%", width: "90%", left: "5%", right: "5%" }}
                    icon={<FeedbackIcon fontSize="inherit" />}>{t('noCreditsLeft')}</Alert>}
        </div>
    );
}

export default App;
